
import React from "react";
import { MapPin, Info, Map } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface SearchActionsProps {
  onUseCurrentLocation: () => void;
  onToggleFallbackMap?: () => void;
  useFallbackMap?: boolean;
  isSearching: boolean;
}

const SearchActions = ({
  onUseCurrentLocation,
  onToggleFallbackMap,
  useFallbackMap = false,
  isSearching
}: SearchActionsProps) => {
  return (
    <>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="outline"
              size="icon"
              onClick={onUseCurrentLocation}
              title="Use current location"
              disabled={isSearching}
            >
              <MapPin className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <p>Use your current location</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      {onToggleFallbackMap && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant={useFallbackMap ? "default" : "outline"}
                size="icon"
                onClick={onToggleFallbackMap}
                title={useFallbackMap ? "Using alternative map" : "Switch to alternative map"}
              >
                <Map className="h-4 w-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>{useFallbackMap ? "Using alternative map" : "Switch to alternative map"}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}

      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button variant="ghost" size="icon" className="text-muted-foreground">
              <Info className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>
            <div className="max-w-xs">
              <p className="font-medium mb-1">Location Tips:</p>
              <ul className="text-xs list-disc pl-4 space-y-1">
                <li>Search for an address or place name</li>
                <li>Enter coordinates directly (e.g., 40.7128, -74.0060)</li>
                <li>Use the map to click on a location</li>
                <li>Click the pin icon to use your current location</li>
                {onToggleFallbackMap && <li>Use the alternative map if Google Maps doesn't load</li>}
              </ul>
            </div>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </>
  );
};

export default SearchActions;
